import React from 'react'
import { SaleContactDetails } from '@sales/data/operation/contacts/SaleContactData'
import SaleContactCreditsGrid from '../../../components/grids/SaleContactCreditsGrid';
import ContactCreditDialog from '../../../dialogs/credits/SaleContactCreditDialog';

const SaleContactDetailPopUpCreditsTab = (props: { 
    contactDetails: SaleContactDetails
}) => {
    return (
        <div className='stretched row-based scrollable p-4 container'>
            <SaleContactCreditsGrid
                contact={props.contactDetails.contact}
                credits={Object.values(props.contactDetails.credits)}
                modifyGridProps={(gridProps) => ({
                    ...gridProps,
                    header: undefined,
                    noRecordsConfig: {
                        message: 'No credits were found for this contact',
                        action: {
                            prompt: 'To create one, click the button above',
                            button: () => (
                                <ContactCreditDialog.Button
                                    contactId={props.contactDetails.contact.id}
                                    classes='button-highlight'
                                />
                            )
                        }
                    },
                    actions: {
                        ...gridProps.actions,
                        gridActions: {
                            width: '',
                            rendering: () => (
                                <ContactCreditDialog.Button
                                    contactId={props.contactDetails.contact.id}
                                    classes='button-link'
                                />
                            )
                        }
                    }
                })}
            />
        </div>
    )
}

export default SaleContactDetailPopUpCreditsTab